"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _context9 = _interopRequireDefault(require("../Theme/context"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _CheckboxIconContainerComponent = _interopRequireDefault(require("./CheckboxIconContainerComponent"));
var _enterNextFocus = _interopRequireDefault(require("./enterNextFocus"));
var _excluded = ["classNames", "disableUseStyle", "size", "multiple", "disabled", "placeholder", "noOptionsText", "onChange", "onBlur", "PaperComponent", "PaperProps", "MenuComponent", "MenuComponentProps", "effect", "containerRef", "checkbox", "checkboxIconToEnd", "getCheckboxIconButtonProps", "className", "parentButtonPaperDisabled", "getFocus", "enableWiderMenu", "ValueComponent", "filter"],
  _excluded2 = ["children", "onKeyDown"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref5) {
  var _value, _menu, _MenuComponentProps$c, _MenuComponentProps$P3, _MenuComponentProps$P4, _MenuComponentProps$P5, _MenuComponentProps$P6, _MenuComponentProps$P7, _MenuComponentProps$P8, _MenuComponentProps$P9, _MenuComponentProps$P0, _MenuComponentProps$P1, _MenuComponentProps$P10, _MenuComponentProps$P11, _MenuComponentProps$M;
  var classNames = props.classNames,
    disableUseStyle = props.disableUseStyle,
    size = props.size,
    multiple = props.multiple,
    disabled = props.disabled,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$noOptionsText = props.noOptionsText,
    noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
    onChange = props.onChange,
    onBlur = props.onBlur,
    _props$PaperComponent = props.PaperComponent,
    PaperComponent = _props$PaperComponent === void 0 ? _Paper["default"] : _props$PaperComponent,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    _props$MenuComponent = props.MenuComponent,
    MenuComponent = _props$MenuComponent === void 0 ? _Menu["default"] : _props$MenuComponent,
    _props$MenuComponentP = props.MenuComponentProps,
    MenuComponentProps = _props$MenuComponentP === void 0 ? {} : _props$MenuComponentP,
    effect = props.effect,
    containerRef = props.containerRef,
    _props$checkbox = props.checkbox,
    checkbox = _props$checkbox === void 0 ? false : _props$checkbox,
    checkboxIconToEnd = props.checkboxIconToEnd,
    getCheckboxIconButtonProps = props.getCheckboxIconButtonProps,
    className = props.className,
    parentButtonPaperDisabled = props.parentButtonPaperDisabled,
    getFocus = props.getFocus,
    _props$enableWiderMen = props.enableWiderMenu,
    enableWiderMenu = _props$enableWiderMen === void 0 ? false : _props$enableWiderMen,
    _props$ValueComponent = props.ValueComponent,
    ValueComponent = _props$ValueComponent === void 0 ? 'div' : _props$ValueComponent,
    filter = props.filter,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var variant = PaperProps.variant,
    color = PaperProps.color;
  var _rest2$InputComponent = rest2.InputComponent,
    InputComponent = _rest2$InputComponent === void 0 ? 'input' : _rest2$InputComponent,
    value = rest2.value,
    menu = rest2.menu;
  value = typeof value === 'object' && (_value = value) !== null && _value !== void 0 && _value.length ? value : [];
  menu = typeof menu === 'object' && (_menu = menu) !== null && _menu !== void 0 && _menu.length ? menu : [];
  var themeContext = (0, _react.useContext)(_context9["default"]);
  var useStyle = themeContext.useStyle;
  if (typeof useStyle === 'function' && !disableUseStyle) {
    useStyle(classNames);
  }
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    inputValue = _useState2[0],
    _setValue = _useState2[1];
  var inputRef = (0, _react.useRef)();
  var inputRefFilterFocus = (0, _react.useRef)({});
  if (filter && !props.InputComponent) {
    InputComponent = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
      var _menu2;
      var children = _ref.children,
        onKeyDown = _ref.onKeyDown,
        props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
      var _useState3 = (0, _react.useState)(''),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        filterValue = _useState4[0],
        setFilterValue = _useState4[1];
      var _useState5 = (0, _react.useState)(false),
        _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
        focus = _useState6[0],
        setFocus = _useState6[1];
      inputRefFilterFocus.current.filterFocus = setFocus;
      var visible = (0, _react.useRef)([]);
      return /*#__PURE__*/_react["default"].createElement("input", Object.assign({}, props, {
        ref: ref
      }, focus && (_menu2 = menu) !== null && _menu2 !== void 0 && _menu2.length ? {
        className: (0, _clsx3["default"])(props.className, classNames.selectFilterInput, classNames.textBase),
        value: filterValue || '',
        onChange: function () {
          var _onChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(e) {
            var _menuItemsRef$current;
            var value;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  value = e.target.value || '';
                  _context.next = 4;
                  return setFilterValue(value);
                case 4:
                  visible.current = [];
                  if ((_menuItemsRef$current = menuItemsRef.current) !== null && _menuItemsRef$current !== void 0 && _menuItemsRef$current.length) {
                    menuItemsRef.current.forEach(function (_ref2, i) {
                      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
                        textContent = _ref3[0],
                        button = _ref3[1];
                      if (button) {
                        if (value && (textContent && !textContent.toLowerCase().startsWith(value.toLowerCase()) || !textContent)) {
                          button.style.display = 'none';
                        } else {
                          button.style.display = '';
                          visible.current.push([button, i]);
                        }
                      }
                    });
                  }
                case 6:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function onChange(_x) {
            return _onChange.apply(this, arguments);
          }
          return onChange;
        }(),
        onKeyDown: function () {
          var _onKeyDown = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(e) {
            var _visible$current, menuItemData, _popoverActions$curre, _popoverActions$curre2, _popoverActions$curre3, _value2;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(e.key === 'Enter')) {
                    _context2.next = 13;
                    break;
                  }
                  e.preventDefault();
                  if (!(((_visible$current = visible.current) === null || _visible$current === void 0 ? void 0 : _visible$current.length) === 1)) {
                    _context2.next = 13;
                    break;
                  }
                  menuItemData = menu[visible.current[0][1]];
                  if (!menuItemData) {
                    _context2.next = 13;
                    break;
                  }
                  _value2 = menuItemData === null || menuItemData === void 0 ? void 0 : menuItemData.value;
                  _context2.next = 8;
                  return setValue([_value2]);
                case 8:
                  _context2.next = 10;
                  return (_popoverActions$curre = popoverActions.current) === null || _popoverActions$curre === void 0 ? void 0 : (_popoverActions$curre2 = _popoverActions$curre.modal) === null || _popoverActions$curre2 === void 0 ? void 0 : (_popoverActions$curre3 = _popoverActions$curre2.actions) === null || _popoverActions$curre3 === void 0 ? void 0 : _popoverActions$curre3.setOpen(false);
                case 10:
                  if (!MenuComponentProps.onChange) {
                    _context2.next = 13;
                    break;
                  }
                  _context2.next = 13;
                  return MenuComponentProps.onChange(e, _value2);
                case 13:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function onKeyDown(_x2) {
            return _onKeyDown.apply(this, arguments);
          }
          return onKeyDown;
        }()
      } : {
        onKeyDown: onKeyDown
      }));
    });
  }
  function setValue(_x3) {
    return _setValue2.apply(this, arguments);
  }
  function _setValue2() {
    _setValue2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _setValue(value);
          case 2:
            if (inputRef.current) {
              inputRef.current.value = value ? value.join(',') : '';
            }
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _setValue2.apply(this, arguments);
  }
  var lastPropsValue = (0, _react.useRef)(props.value);
  (0, _react.useEffect)(function () {
    try {
      if (typeof props.value !== 'undefined' && JSON.stringify(lastPropsValue.current) !== JSON.stringify(props.value)) {
        if (JSON.stringify(inputValue) !== JSON.stringify(props.value)) {
          var _props$value;
          lastPropsValue.current = props.value;
          var newValue = typeof props.value === 'object' && (_props$value = props.value) !== null && _props$value !== void 0 && _props$value.length ? props.value : [];
          setValue(newValue);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [props.value]);
  var popoverActions = (0, _react.useRef)();
  var paperRef = (0, _react.useRef)();
  var menuActions = (0, _react.useRef)({});
  var labelRef = (0, _react.useRef)({});
  var menuItemsRef = (0, _react.useRef)([]);
  function valueToText(inputValue) {
    var t = [];
    function findMenuRecursive(menu, value) {
      var label = '';
      var foundMenu = menu.find(function (menu) {
        if ((menu === null || menu === void 0 ? void 0 : menu.value) === value) {
          return true;
        }
      });
      if (foundMenu) {
        label = foundMenu.label;
      } else {
        menu.forEach(function (menu) {
          var _menu$items;
          if (menu !== null && menu !== void 0 && (_menu$items = menu.items) !== null && _menu$items !== void 0 && _menu$items.length) {
            if (!label) {
              var foundLabel = findMenuRecursive(menu.items, value);
              if (foundLabel) {
                label = foundLabel;
              }
            }
          }
        });
      }
      return label;
    }
    inputValue.forEach(function (value) {
      var label = findMenuRecursive(menu, value) || value.toString();
      t.push(label);
    });
    return t.join(', ');
  }
  function setFocus(_x4) {
    return _setFocus.apply(this, arguments);
  }
  function _setFocus() {
    _setFocus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7(value) {
      var _inputRefFilterFocus$;
      var _inputRef$current;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (paperRef.current) {
              if (value) {
                paperRef.current.setAttribute('focus', '');
              } else {
                paperRef.current.removeAttribute('focus');
              }
            }
            _context7.next = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });
          case 3:
            if ((_inputRefFilterFocus$ = inputRefFilterFocus.current) !== null && _inputRefFilterFocus$ !== void 0 && _inputRefFilterFocus$.filterFocus) {
              if (value) {
                inputRefFilterFocus.current.filterFocus(true);
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
              } else {
                inputRefFilterFocus.current.filterFocus(false);
              }
            }
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _setFocus.apply(this, arguments);
  }
  function defaultFocus() {
    return _defaultFocus.apply(this, arguments);
  }
  function _defaultFocus() {
    _defaultFocus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
      var _popoverActions$curre0, _popoverActions$curre1, _popoverActions$curre10;
      var _popoverActions$curre11, _popoverActions$curre12, _popoverActions$curre13, open;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!((_popoverActions$curre0 = popoverActions.current) !== null && _popoverActions$curre0 !== void 0 && (_popoverActions$curre1 = _popoverActions$curre0.modal) !== null && _popoverActions$curre1 !== void 0 && (_popoverActions$curre10 = _popoverActions$curre1.actions) !== null && _popoverActions$curre10 !== void 0 && _popoverActions$curre10.setOpen)) {
              _context8.next = 5;
              break;
            }
            open = (_popoverActions$curre11 = popoverActions.current) === null || _popoverActions$curre11 === void 0 ? void 0 : (_popoverActions$curre12 = _popoverActions$curre11.modal) === null || _popoverActions$curre12 === void 0 ? void 0 : (_popoverActions$curre13 = _popoverActions$curre12.actions) === null || _popoverActions$curre13 === void 0 ? void 0 : _popoverActions$curre13.getOpen();
            if (!(!open && !disabled)) {
              _context8.next = 5;
              break;
            }
            _context8.next = 5;
            return popoverActions.current.modal.actions.setOpen(true);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _defaultFocus.apply(this, arguments);
  }
  var focus = getFocus ? getFocus({
    defaultFocus: defaultFocus,
    setFocus: setFocus
  }) : defaultFocus;
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setValue: setValue,
          getValue: function getValue() {
            return value;
          },
          focus: focus
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setValue: function setValue() {},
            getValue: function getValue() {},
            focus: function focus() {}
          }
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(PaperComponent, Object.assign({
    size: 'none',
    elevation: 0,
    disabled: disabled
  }, PaperProps, {
    color: color,
    variant: variant !== 'contained' && variant !== 'outlined' ? 'text' : variant,
    className: (0, _clsx3["default"])(classNames.selectBasePaper, className, PaperProps.className),
    ref: function ref(e) {
      paperRef.current = e;
      if (_ref5) {
        if (typeof _ref5 === 'function') {
          _ref5(e);
        } else if (_ref5 && typeof _ref5 === 'object') {
          _ref5.current = e;
        }
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(InputComponent, {
    value: inputValue.join(','),
    ref: inputRef,
    type: 'text',
    className: (0, _clsx3["default"])(classNames.hiddenInput),
    disabled: disabled,
    onChange: function onChange(e) {
      e.preventDefault();
    },
    onKeyDown: function onKeyDown(e) {
      (0, _enterNextFocus["default"])(e);
    }
  }), /*#__PURE__*/_react["default"].createElement(MenuComponent, Object.assign({}, MenuComponentProps, {
    menu: menu.length ? menu : [{
      label: noOptionsText,
      disabled: true
    }],
    classes: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, MenuComponentProps.classes ? MenuComponentProps.classes : {}), {}, {
      popoverPaper: (0, _clsx3["default"])(classNames.selectMenuPopoverPaper, (_MenuComponentProps$c = MenuComponentProps.classes) === null || _MenuComponentProps$c === void 0 ? void 0 : _MenuComponentProps$c.popoverPaper)
    }),
    PopoverProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, MenuComponentProps.PopoverProps ? MenuComponentProps.PopoverProps : {}), {}, {
      getAnchorElement: function getAnchorElement() {
        return containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
      },
      onOpen: function () {
        var _onOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
          var _MenuComponentProps$P;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                setFocus(true);
                if (!onChange) {
                  _context3.next = 4;
                  break;
                }
                _context3.next = 4;
                return onChange(null, (0, _toConsumableArray2["default"])(inputValue));
              case 4:
                if (!((_MenuComponentProps$P = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P !== void 0 && _MenuComponentProps$P.onOpen)) {
                  _context3.next = 7;
                  break;
                }
                _context3.next = 7;
                return MenuComponentProps.PopoverProps.onOpen();
              case 7:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function onOpen() {
          return _onOpen.apply(this, arguments);
        }
        return onOpen;
      }(),
      onClose: function () {
        var _onClose = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
          var _menuActions$current$, _MenuComponentProps$P2;
          var sendToBlur, _value3;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                sendToBlur = (0, _toConsumableArray2["default"])(inputValue);
                if (!((_menuActions$current$ = menuActions.current.actions) !== null && _menuActions$current$ !== void 0 && _menuActions$current$.getValue)) {
                  _context4.next = 6;
                  break;
                }
                _value3 = menuActions.current.actions.getValue();
                sendToBlur = (0, _toConsumableArray2["default"])(_value3);
                _context4.next = 6;
                return setValue(_value3);
              case 6:
                if (!((_MenuComponentProps$P2 = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P2 !== void 0 && _MenuComponentProps$P2.onClose)) {
                  _context4.next = 9;
                  break;
                }
                _context4.next = 9;
                return MenuComponentProps.PopoverProps.onClose();
              case 9:
                setFocus(false);
                if (!onBlur) {
                  _context4.next = 13;
                  break;
                }
                _context4.next = 13;
                return onBlur(null, sendToBlur);
              case 13:
                menuItemsRef.current = [];
              case 14:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function onClose() {
          return _onClose.apply(this, arguments);
        }
        return onClose;
      }(),
      popperOptions: {
        placement: 'bottom',
        modifiers: [].concat((0, _toConsumableArray2["default"])((_MenuComponentProps$P3 = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P3 !== void 0 && (_MenuComponentProps$P4 = _MenuComponentProps$P3.popperOptions) !== null && _MenuComponentProps$P4 !== void 0 && _MenuComponentProps$P4.modifiers ? MenuComponentProps.PopoverProps.popperOptions.modifiers.filter(function (m) {
          return m.name !== 'offset' && m.name !== 'flip' && m.name !== 'matchReferenceSize';
        }) : []), (0, _toConsumableArray2["default"])((_MenuComponentProps$P5 = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P5 !== void 0 && (_MenuComponentProps$P6 = _MenuComponentProps$P5.popperOptions) !== null && _MenuComponentProps$P6 !== void 0 && (_MenuComponentProps$P7 = _MenuComponentProps$P6.modifiers) !== null && _MenuComponentProps$P7 !== void 0 && _MenuComponentProps$P7.find(function (m) {
          return m.name === 'offset';
        }) ? MenuComponentProps.PopoverProps.popperOptions.modifiers.filter(function (m) {
          return m.name === 'offset';
        }) : [{
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        }]), (0, _toConsumableArray2["default"])((_MenuComponentProps$P8 = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P8 !== void 0 && (_MenuComponentProps$P9 = _MenuComponentProps$P8.popperOptions) !== null && _MenuComponentProps$P9 !== void 0 && (_MenuComponentProps$P0 = _MenuComponentProps$P9.modifiers) !== null && _MenuComponentProps$P0 !== void 0 && _MenuComponentProps$P0.find(function (m) {
          return m.name === 'flip';
        }) ? MenuComponentProps.PopoverProps.popperOptions.modifiers.filter(function (m) {
          return m.name === 'flip';
        }) : [{
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom']
          }
        }]), (0, _toConsumableArray2["default"])((_MenuComponentProps$P1 = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P1 !== void 0 && (_MenuComponentProps$P10 = _MenuComponentProps$P1.popperOptions) !== null && _MenuComponentProps$P10 !== void 0 && (_MenuComponentProps$P11 = _MenuComponentProps$P10.modifiers) !== null && _MenuComponentProps$P11 !== void 0 && _MenuComponentProps$P11.find(function (m) {
          return m.name === 'matchReferenceSize';
        }) ? MenuComponentProps.PopoverProps.popperOptions.modifiers.filter(function (m) {
          return m.name === 'matchReferenceSize';
        }) : [{
          name: 'matchReferenceSize',
          enabled: true,
          fn: function fn(_ref4) {
            var state = _ref4.state;
            var referenceSize = containerRef.current ? containerRef.current.offsetWidth : state.rects.reference.width;
            if (enableWiderMenu) {
              state.styles.popper.minWidth = "".concat(referenceSize, "px");
            } else {
              state.styles.popper.width = "".concat(referenceSize, "px");
            }
          },
          phase: 'beforeWrite',
          requires: ['computeStyles']
        }]))
      },
      AnchorComponent: /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
        var _useState7 = (0, _react.useState)(inputValue !== null && inputValue !== void 0 && inputValue.length ? valueToText(inputValue) : placeholder),
          _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
          value = _useState8[0],
          setValue = _useState8[1];
        labelRef.current = {
          actions: {
            setValue: setValue
          }
        };
        return /*#__PURE__*/_react["default"].createElement(ValueComponent, {
          ref: ref,
          className: (0, _clsx3["default"])(classNames.selectValue, (0, _defineProperty2["default"])({}, classNames.selectValuePlaceholder, !(inputValue !== null && inputValue !== void 0 && inputValue.length)))
        }, value);
      }),
      effect: function effect(p) {
        var _MenuComponentProps$P12;
        popoverActions.current = p;
        if ((_MenuComponentProps$P12 = MenuComponentProps.PopoverProps) !== null && _MenuComponentProps$P12 !== void 0 && _MenuComponentProps$P12.effect) {
          var _MenuComponentProps$P13;
          (_MenuComponentProps$P13 = MenuComponentProps.PopoverProps) === null || _MenuComponentProps$P13 === void 0 ? void 0 : _MenuComponentProps$P13.effect(p);
        }
      }
    }),
    PaperProps: (0, _objectSpread2["default"])({
      arrow: false,
      color: color,
      variant: 'contained',
      size: 'input-' + size
    }, MenuComponentProps.PaperProps ? MenuComponentProps.PaperProps : {}),
    MenuItemProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      variant: 'contained',
      size: size
    }, checkbox ? (0, _objectSpread2["default"])({}, checkboxIconToEnd ? {
      EndIconContainerComponent: function EndIconContainerComponent(props) {
        return (0, _CheckboxIconContainerComponent["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          getCheckboxIconButtonProps: getCheckboxIconButtonProps
        }, props), {}, {
          className: (0, _clsx3["default"])(classNames.checkboxIconOnMenu, props.className)
        }));
      },
      endIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
    } : {
      StartIconContainerComponent: function StartIconContainerComponent(props) {
        return (0, _CheckboxIconContainerComponent["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          getCheckboxIconButtonProps: getCheckboxIconButtonProps
        }, props), {}, {
          className: (0, _clsx3["default"])(classNames.checkboxIconOnMenu, props.className)
        }));
      },
      startIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
    }) : {}), MenuComponentProps.MenuItemProps ? MenuComponentProps.MenuItemProps : {}), {}, {
      className: (0, _clsx3["default"])(classNames.selectMenuItem, (0, _defineProperty2["default"])({}, classNames.checkboxMenuItem, checkbox), (_MenuComponentProps$M = MenuComponentProps.MenuItemProps) === null || _MenuComponentProps$M === void 0 ? void 0 : _MenuComponentProps$M.className),
      ref: function ref(e) {
        var _MenuComponentProps$M2;
        if (e) {
          menuItemsRef.current.push([e.textContent, e]);
        }
        var ref = (_MenuComponentProps$M2 = MenuComponentProps.MenuItemProps) === null || _MenuComponentProps$M2 === void 0 ? void 0 : _MenuComponentProps$M2.ref;
        if (ref) {
          if (typeof ref === 'function') {
            ref(e);
          } else if (ref && typeof ref === 'object') {
            ref.current = e;
          }
        }
      }
    }),
    value: inputValue,
    selectable: true,
    multiple: multiple,
    onChange: function () {
      var _onChange2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(e, value) {
        var _labelRef$current$act, _popoverActions$curre4, _popoverActions$curre5, _popoverActions$curre6;
        var textValue, _popoverActions$curre7, _popoverActions$curre8, _popoverActions$curre9, open;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              textValue = value !== null && value !== void 0 && value.length ? valueToText(value) : placeholder;
              if (!((_labelRef$current$act = labelRef.current.actions) !== null && _labelRef$current$act !== void 0 && _labelRef$current$act.setValue)) {
                _context5.next = 4;
                break;
              }
              _context5.next = 4;
              return labelRef.current.actions.setValue(textValue);
            case 4:
              if (!(!multiple && (_popoverActions$curre4 = popoverActions.current) !== null && _popoverActions$curre4 !== void 0 && (_popoverActions$curre5 = _popoverActions$curre4.modal) !== null && _popoverActions$curre5 !== void 0 && (_popoverActions$curre6 = _popoverActions$curre5.actions) !== null && _popoverActions$curre6 !== void 0 && _popoverActions$curre6.setOpen)) {
                _context5.next = 9;
                break;
              }
              open = (_popoverActions$curre7 = popoverActions.current) === null || _popoverActions$curre7 === void 0 ? void 0 : (_popoverActions$curre8 = _popoverActions$curre7.modal) === null || _popoverActions$curre8 === void 0 ? void 0 : (_popoverActions$curre9 = _popoverActions$curre8.actions) === null || _popoverActions$curre9 === void 0 ? void 0 : _popoverActions$curre9.getOpen();
              if (!open) {
                _context5.next = 9;
                break;
              }
              _context5.next = 9;
              return popoverActions.current.modal.actions.setOpen(false);
            case 9:
              if (!MenuComponentProps.onChange) {
                _context5.next = 12;
                break;
              }
              _context5.next = 12;
              return MenuComponentProps.onChange(e, value);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function onChange(_x5, _x6) {
        return _onChange2.apply(this, arguments);
      }
      return onChange;
    }(),
    effect: function effect(p) {
      var actions = p.actions;
      menuActions.current.actions = actions;
      if (MenuComponentProps.effect) {
        MenuComponentProps.effect(p);
      }
    }
  })));
});